module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="background '+
((__t=( background ))==null?'':__t)+
'">\n	';
 if (show_back_button) { 
__p+='\n		<button class="js-back back-button">\n			<span class="ion-ios-arrow-back"></span>\n		</button>\n	';
 } 
__p+='\n	<div class="form-container"></div>\n</div>\n<div class="advert"></div>';
}
return __p;
};
